angular.module('elfium').service('reportDtoService', ['orderByFilter', 
    function (orderByFilter) {
        var that = this;
        that.buildReportsFromDto = function (businessCaseId, reportsDto) {
            var reports = [];
            angular.forEach(reportsDto, function (reportPhases, taskType) {
                angular.forEach(reportPhases, function (reportRealizations, reportPhase) {
                    angular.forEach(reportRealizations, function (reportDtos, reportRealization) {
                        angular.forEach(reportDtos, function (reportDto) {
                            reports.push(that._buildReportItem(businessCaseId, taskType, reportPhase, reportRealization, reportDto));
                        });
                    });
                });
            });
            return reports;
        };
        that._buildReportItem = function (businessCaseId, taskType, reportPhase, reportRealization, reportDto) {
            return {
                obchodniPripadId: businessCaseId,
                typ: taskType,
                faze: reportPhase,
                realizace: reportRealization,
                id: reportDto.id,
                termin: reportDto.date,
                objem: reportDto.volume,
                isLocked: reportDto.isLocked
            };
        };
        that.buildReportsDto = function (reports) {
            var reportsDto = {};
            angular.forEach(reports, function (report) {
                reportsDto[report.typ] = reportsDto[report.typ] || {};
                reportsDto[report.typ][report.faze] = reportsDto[report.typ][report.faze] || {};
                reportsDto[report.typ][report.faze][report.realizace] = reportsDto[report.typ][report.faze][report.realizace] || [];
                reportsDto[report.typ][report.faze][report.realizace].push(that.buildReportDto(report));
            });
            that._orderReportsDto(reportsDto);
            return reportsDto;
        };
        that.buildReportDto = function (report) {
            return {
                id: report.id,
                date: report.termin,
                volume: report.objem,
                isLocked: report.isLocked
            };
        };
        that._orderReportsDto = function (reportsDto) {
            angular.forEach(reportsDto, function (reportPhases, taskType) {
                angular.forEach(reportPhases, function (reportRealizations, reportPhase) {
                    angular.forEach(reportRealizations, function (reportDtos, reportRealization) {
                        reportRealizations[reportRealization] = orderByFilter(reportDtos, 'date');
                    });
                });
            });
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportDtoService.ts